import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { makeApiCall } from '../../services/httpService_notinuse';
import { API_BASE_URL } from '../../config/apiConfig';
import toast from 'react-hot-toast';
import DContext from '../../context/DContext';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import ContentLoader from '../loader/ContentLoader';



const UpdateFlight = () => {
  const location = useLocation();


  const { authState, authDispatch, logout } = useContext(DContext);
  const { user } = authState;
  
  const [loading, setLoading] = useState(false);
  const [airlinesDropdown, setAirlinesDropdown] = useState([]);
  const initialFlightDetail = {
    airlineId: "",
    flightName: "",
    flightCode: "",
    flightNumber: "",
    depAirportId: "",
    depAirportCode: "",
    depCityName: "",
    depCountry: "",
    arrAirportId: "",
    arrAirportCode: "",
    arrCityName: "",
    arrCountry: "",
    depTime: "",
    arrTime: "",
    depTerminal: "",
    arrTerminal: ""
  };
  const [flightDetail, setFlightDetail] = useState(initialFlightDetail);


  useEffect(() => {
    loadAirlines();
  }, []);

  const getModule = () => {
    let tempModuleVal = location.pathname.split("/")[1];
    const moduleData = user?.menu_access.find(ele => ele.route_to.includes(tempModuleVal));
    return moduleData;
  }


  const showSwal = (title, text, icon) => {
    withReactContent(Swal).fire({
      title,
      text,
      icon // 'success' | 'error' | 'warning' | 'info' | 'question'
    })
  }

  const loadAirlines = async () => {
    try {
      let apiUrl = `${API_BASE_URL}/api/utils/airlines?&page=1&limit=500`;
      let apiRes = await makeApiCall("GET", null, apiUrl);
      console.log(apiRes);
      if (apiRes?.statusCode == 200) {
        //toast.success(apiRes.message);
        setAirlinesDropdown(apiRes?.resData);
        return apiRes.resData;
      } else {
        toast.error(apiRes.message);
        //showSwal("Error",apiRes.message,"error")

      }
    } catch (err) {
      console.log("Fatal Error", err);
      //toast.error("Something Went Wrong...");
      showSwal("Error", "Something went wrong...", "error")
    }
  }

  const loadAirports = async (searchq = null) => {
    try {
      let apiUrl = `${API_BASE_URL}/api/utils/airport?searchq=${searchq}&page=1&limit=20`;
      let apiRes = await makeApiCall("GET", null, apiUrl);
      console.log(apiRes);
      if (apiRes?.statusCode == 200) {
        //toast.success(apiRes.message);
        return apiRes.resData;
      } else {
        toast.error(apiRes.message);
      }
    } catch (err) {
      console.log("Fatal Error", err);
      //toast.error("Something Went Wrong...");
      showSwal("Error", "Something went wrong...", "error")
    }
  }


  const handleSelectChange = (selectedOption) => {
    console.log("Selected option:", selectedOption);
    setFlightDetail({
      ...flightDetail,
      flightName: selectedOption?.airline_name,
      airlineId: selectedOption?.value,
      flightCode: selectedOption?.airline_code
    })
  };

  const handleSelectChangeDepAirport = (selectedOption) => {
    console.log("Selected option:", selectedOption);
    setFlightDetail({
      ...flightDetail,
      depAirportId: selectedOption?.value,
      depAirportCode: selectedOption?.airport_code,
      depCityName: selectedOption?.city_name,
      depCountry: selectedOption?.country_name
    })
  };


  const handleSelectChangeArrAirport = (selectedOption) => {
    console.log("Selected option:", selectedOption);
    setFlightDetail({
      ...flightDetail,
      arrAirportId: selectedOption?.value,
      arrAirportCode: selectedOption?.airport_code,
      arrCityName: selectedOption?.city_name,
      arrCountry: selectedOption?.country_name
    })
  };


  const handleChange = (e) => {
    setFlightDetail({ ...flightDetail, [e.target.name]: e.target.value });
  }

  const handleSubmit = async (e) => {
    try {
      setLoading(true);
      let bodyPayload = {};
      e.preventDefault();
      bodyPayload.module_info = getModule();
      bodyPayload.form_data = flightDetail;
      console.log("final form data", bodyPayload);
      let apiUrl = `${API_BASE_URL}/api/flights`;
      let apiRes = await makeApiCall("POST", bodyPayload, apiUrl);
      console.log(apiRes);
      if (apiRes?.statusCode == 200) {
        showSwal("Success", apiRes.message, "success");
        //setFlightDetail(initialFlightDetail);
      } else {
        console.log(apiRes?.response?.data?.message)
        if (apiRes?.response?.data?.message) {
          showSwal("Error",apiRes?.response?.data?.message,"error")
        } else {
          toast.error(apiRes.message);
        }
      }
    } catch (err) {
      showSwal("Error", "Something went wrong...", "error")
    } finally {
      setLoading(false);
    }
  }


  // Debounce the actual fetch call
  // const debouncedLoadAirports = useCallback(
  //   debounce((value) => {
  //     loadAirports(value);
  //   }, 300),
  //   []
  // );
  if (loading) return (<ContentLoader loaderType="circleSpin"/>)
  return (
    <>
      {/* <button className='btn btn-primary' onClick={() => showSwal("Error", "Something went wrong...", "error")}>Sweet Alert Modal</button> */}
      <section className="section dashboard">
        <div class="row">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-body">
                <div className="d-flex align-items-center justify-content-between">
                  <h5 className="card-title"><i class="bi bi-plus-circle-fill"></i> New Flight Detail</h5>
                  <Link to="/flight/list" className="btn btn-outline-info" style={{ padding: '2px 10px 2px 10px', marginBottom: '10px' }}>
                    <i className="bi bi-skip-backward-fill"></i> Back To Flight Detail
                  </Link>
                </div>
                <form onSubmit={handleSubmit}>
                  <div class="row g-3">
                    <div class="col-md-3">
                      <div class="form-floating">
                        <Select
                          options={airlinesDropdown}
                          onMenuOpen={() => console.log('Menu opened (click detected)')}
                          onChange={handleSelectChange}
                          placeholder="Select airline"
                          isSearchable={true}
                          isClearable={true}
                          menuPortalTarget={document.body}
                          styles={{ menuPortal: (base) => ({ ...base, zIndex: 2000 }) }}
                        />

                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="form-floating">
                        {/* <input type="file" class="form-control" id="FlightLogoUploadInput" />
                      <label for="FlightLogoUploadInput">Flight Logo</label> */}
                        <img src={`https://images.kiwi.com/airlines/32/${flightDetail?.flightCode}.png`} />
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="form-floating">
                        <input type="text"
                          class="form-control"
                          id="FlightCodeInput"
                          placeholder="Flight Code"
                          maxLength={2}
                          style={{ textTransform: 'uppercase' }}
                          name="flightCode"
                          value={flightDetail?.flightCode || ""}
                          readOnly
                        />
                        <label for="FlightCodeInput">Flight Code</label>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="form-floating">
                        <input type="number" min="0"
                          class="form-control"
                          id="FlightNumberInput"
                          placeholder="Flight Number"
                          name="flightNumber"
                          value={flightDetail?.flightNumber || ""}
                          onChange={handleChange}
                        />
                        <label for="FlightNumberInput">Flight Number</label>
                      </div>
                    </div>

                  </div>
                  <br />
                  <div class="row g-3">
                    <div class="col-md-3">
                      <div class="form-floating">
                        {/* <Select
                        options={airportDropdown}
                        onMenuOpen={
                          airlinesDropdown.length == 0 ? () => loadAirports() : undefined
                        }
                        onInputChange={(inputValue, { action }) => {
                          if (action === 'input-change') {
                            console.log('Search text:', inputValue);
                            debouncedLoadAirports(inputValue);
                          }
                        }}
                        isSearchable={true}
                        isClearable={true}
                      /> */}
                        <AsyncSelect
                          cacheOptions
                          name="airport_dropdown"
                          placeholder="Search arrival airport..."
                          loadOptions={loadAirports}
                          onChange={handleSelectChangeDepAirport}
                          defaultOptions={false}
                          isClearable
                          isSearchable
                          menuPortalTarget={document.body}
                          styles={{ menuPortal: (base) => ({ ...base, zIndex: 2000 }) }}
                        />
                      </div>

                    </div>
                    <div class="col-md-3">
                      <div class="form-floating">
                        <input
                          type="text"
                          class="form-control"
                          id="DepartureAirportCodeInput"
                          placeholder="Departure Airport Code"
                          // maxLength={3} 
                          style={{ textTransform: 'uppercase' }}
                          readOnly
                          name="depAirportCode"
                          value={flightDetail?.depAirportCode || ""}
                        />
                        <label for="DepartureAirportCodeInput">Departure Airport Code</label>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="form-floating">
                        <input
                          type="text"
                          class="form-control"
                          id="DepartureCityInput"
                          placeholder="Departure City"
                          name="depCityName"
                          value={flightDetail?.depCityName || ""}
                          onChange={handleChange}

                        />
                        <label for="DepartureCityInput">Departure City Name</label>
                      </div>
                    </div>
                    {/* <div class="col-md-2">
                    <div class="form-floating">
                      <input
                        type="text"
                        class="form-control"
                        id="DepartureCityCodeInput"
                        placeholder="Departure City Code"
                        readOnly
                        name="depCityCode"
                        value={flightDetail?.depCityCode || ""}
                      />
                      <label for="DepartureCityCodeInput">Departure City Code</label>
                    </div>
                  </div> */}
                    <div className="col-md-3">
                      <div className="form-floating mb-3">
                        <input
                          type="text"
                          class="form-control"
                          id="DepartureCountry"
                          placeholder="Departure Country"
                          name="depCountry"
                          value={flightDetail?.depCountry || ""}
                        />
                        <label htmlFor="DepartureCountry">Departure Country</label>
                      </div>
                    </div>
                  </div>
                  <br />
                  <div class="row g-3">
                    <div class="col-md-3">
                      <div class="form-floating">
                        <AsyncSelect
                          cacheOptions
                          name="airport_dropdown"
                          placeholder="Search arrival airport..."
                          loadOptions={loadAirports}
                          onChange={handleSelectChangeArrAirport}
                          defaultOptions={false}
                          isClearable
                          isSearchable
                          menuPortalTarget={document.body}
                          styles={{ menuPortal: (base) => ({ ...base, zIndex: 2000 }) }}
                        />
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="form-floating">
                        <input
                          type="text"
                          class="form-control"
                          id="ArrivalAirportCodeInput"
                          placeholder="Arrival Airport Code"
                          // maxLength={3}
                          style={{ textTransform: 'uppercase' }}
                          readOnly
                          name="arrAirportcode"
                          value={flightDetail?.arrAirportCode || ""}
                        />
                        <label for="ArrivalAirportCodeInput">Arrival Airport Code</label>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="form-floating">
                        <input
                          type="text"
                          class="form-control"
                          id="ArrivalCityInput"
                          placeholder="Arrival City"
                          name="arrCityName"
                          value={flightDetail?.arrCityName || ""}
                          onChange={handleChange}
                        />
                        <label for="ArrivalCityInput">Arrival City Name</label>
                      </div>
                    </div>
                    {/* <div class="col-md-2">
                    <div class="form-floating">
                      <input
                        type="text"
                        class="form-control"
                        id="ArrivalCityCodeInput"
                        placeholder="Arrival City Code"
                        readOnly
                        name="arrCityCode"
                        value={flightDetail?.arrCityCode || ""}
                      />
                      <label for="ArrivalCityCodeInput">Arrival City Code</label>
                    </div>
                  </div> */}
                    <div className="col-md-3">
                      <div className="form-floating mb-3">
                        <input
                          type="text"
                          class="form-control"
                          id="ArrivalCountrySelect"
                          placeholder="Arrival Country"
                          name="arrCountry"
                          value={flightDetail?.arrCountry || ""}
                        />
                        <label htmlFor="ArrivalCountrySelect">Arrival Country</label>
                      </div>
                    </div>
                  </div>
                  <br />
                  <div class="row g-3">
                    <div class="col-md-3">
                      <div class="form-floating">
                        <input
                          type="text"
                          class="form-control"
                          id="DepartureTimeInput"
                          placeholder="Departure Time"
                          maxLength={5}
                          name="depTime"
                          value={flightDetail?.depTime || ""}
                          onChange={handleChange}
                        />
                        <label for="DepartureTimeInput">Departure Time</label>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="form-floating">
                        <input
                          type="text"
                          class="form-control"
                          id="ArrivalTimeInput"
                          placeholder="Arrival Time"
                          maxLength={5}
                          name="arrTime"
                          value={flightDetail?.arrTime || ""}
                          onChange={handleChange}
                        />
                        <label for="ArrivalTimeInput">Arrival Time</label>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="form-floating">
                        <input
                          type="text"
                          class="form-control"
                          id="DepartureTerminalInput"
                          placeholder="Departure Terminal"
                          name="depTerminal"
                          value={flightDetail?.depTerminal || ""}
                          onChange={handleChange}
                        />
                        <label for="DepartureTerminalInput">Departure Terminal</label>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="form-floating">
                        <input
                          type="text"
                          class="form-control"
                          id="ArrivalTerminalInput"
                          placeholder="Arrival Terminal"
                          name="arrTerminal"
                          value={flightDetail?.arrTerminal || ""}
                          onChange={handleChange}
                        />
                        <label for="ArrivalTerminalInput">Arrival Terminal</label>
                      </div>
                    </div>
                  </div>
                  <br />
                  <div class="row g-3 float-right">
                    <button type="submit" class="btn btn-success"><i class="fa-solid fa-floppy-disk"></i> Save Flight Detail</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default UpdateFlight;